import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiAlertCircle,
  FiArrowDownCircle,
  FiGrid,
  FiMap,
  FiShield,
  FiShieldOff,
} from "react-icons/fi";
import { TbReportAnalytics } from "react-icons/tb";
import { LiaFileDownloadSolid } from "react-icons/lia";
type Props = {};

const Sidebar = (props: Props) => {
  const location = useLocation();
  const { pathname } = location;


  return (
    <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear bg-orange">
      {/* <!-- Sidebar Menu --> */}
      <nav className="mt-5 py-4 px-4 lg:mt-1 lg:px-6 text-white">
        {/* <!-- Menu Group --> */}
        <div>
          <h3 className="mb-4 ml-4 text-sm font-semibold text-bodydark2">
            MENU
          </h3>

          <ul className="mb-6 flex flex-col gap-1.5">
            {/* <!-- Menu Item Dashboard --> */}
            <li>
              <NavLink
                to="/"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname === '/' &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <FiGrid /> Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/evictions"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("evictions") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <FiArrowDownCircle /> Evictions
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/preventions"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("preventions") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <FiShield /> Preventions
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/riskmap"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("riskmap") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <FiMap /> Risk Map
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/flash-alerts"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("flash-alerts") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <FiAlertCircle /> Flash Alerts
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/downloads"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("downloads") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <LiaFileDownloadSolid /> Downloads
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/analytics"
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-bodydark1 duration-300 ease-in-out hover:bg-graydark dark:hover:bg-meta-4 ${
                  pathname.includes("analytics") &&
                  "bg-white text-orange dark:bg-meta-4"
                }`}
              >
                <TbReportAnalytics /> Analytics
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
